import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material'
import { RetryMode } from '@src/api/document-api'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface RetryDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: (mode: RetryMode) => void
  isLoading: boolean
  isCurrentlyProcessing?: boolean
  isFinalizing?: boolean
}

export const RetryDialog = ({ open, onClose, onConfirm, isLoading, isCurrentlyProcessing, isFinalizing }: RetryDialogProps) => {
  const { t } = useTranslation()

  const [mode, setMode] = useState<RetryMode>('Full')

  const handleConfirm = () => {
    onConfirm(mode)
  }

  const disabled = isLoading || !!isFinalizing

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('docsAutomation.retryTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>{t('docsAutomation.retryDescription')}</DialogContentText>

        {isCurrentlyProcessing && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            {t('docsAutomation.documentCurrentlyProcessing' as 'common.close')}
          </Alert>
        )}

        <RadioGroup value={mode} onChange={(e) => setMode(e.target.value as RetryMode)}>
          <FormControlLabel value="Full" control={<Radio />} label={t('docsAutomation.retryModeFull')} disabled={disabled} />
          <FormControlLabel
            value="ClassificationOnly"
            control={<Radio />}
            label={t('docsAutomation.retryModeClassificationOnly')}
            disabled={disabled}
          />
          <FormControlLabel
            value="MatchingOnly"
            control={<Radio />}
            label={t('docsAutomation.retryModeMatchingOnly')}
            disabled={disabled}
          />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={disabled}>
          {t('common.cancel')}
        </Button>
        <Button variant="contained" onClick={handleConfirm} loading={isLoading} disabled={disabled}>
          {t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
